import { IStore } from '../../index'

export function getServices(state: IStore) {
  return state.bookingCalendar.reservationModal.servicesModal.services
}
